module.exports = __webpack_public_path__ + "img/play.20b8bdaf.svg";